// price change money
var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "₹{{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';
return dollars
    // return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};
// End price change money

// $('body').on('click','.cstm__grid_label',function(){
//   $(this).parents('.product-form').find('.cstm__grid_label').removeClass('active_variant');
//   $(this).addClass('active_variant');
//   console.log(this);
//   var media_img = $(this).attr('media-img');
//   var media_id = $(this).attr('data-media-id');
//   var img_media_id = $(this).parents('.product-item').find('.product-item__bg__under').attr('data-media-id');
//   var available = $(this).attr('data-available');
//   console.log("available>>>",available)
//   console.log("media_img>>>",media_img)
//   console.log("media_id>>>",media_id)
//   console.log("img_media_id>>>",img_media_id)
//   if(available == 'true'){
//      $(this).parents('.product-form').find('.cstm__add_to_cart').removeAttr('disabled');
//     $(this).parents('.product-form').find('.cstm__add_to_cart .atc__grid__text').text('ADD TO BAG').removeAttr('disabled');  
//   }else{
//    $(this).parents('.product-form').find('.cstm__add_to_cart').attr('disabled','disabled');   
//    $(this).parents('.product-form').find('.cstm__add_to_cart .atc__grid__text').text('Sold Out');   
//   }
//   if(media_img){
//   $(this).parents('.product-form').find('[data-grid-slide]').css('background-image','url(' + media_img + ')');
//   console.log("$(this).parents('.product-form').find('[data-grid-slide]')>>>",$(this).parents('.product-form').find('[data-grid-slide]'))
//   }
//   if(media_id == img_media_id){
//     $(this).parents('.product-item').find('.product-item__bg__under').addClass('show');
//   }
//   else{
//     $(this).parents('.product-item').find('.product-item__bg__under').removeClass('show');
//   }
//  var product_handle = $(this).parent().attr('product-handle');
//   var vid = $(this).attr('data-id');
//   var _this = this;
//   if($(this).parents('.product-form').find('.cstm_collection_visible__btn').hasClass('variant__'+vid)){
//   $(this).parents('.product-form').find('.cstm__add_to_cart').hide();
//   $(this).parents('.product-form').find('.cstm_add_qty').hide();
//   $(this).parents('.product-form').find('.variant__'+vid).show();
//   }
//   else{
//     $(this).parents('.product-form').find('.cstm_collection_visible__btn').hide();
//     $(this).parents('.product-form').find('.cstm__add_to_cart').show();
//   }
//   fetch('/products/'+ product_handle +'?variant='+vid+'&view=collection-grid-price', {
//               credentials: 'same-origin',
//               method: 'GET',
//             }).then(function (content) {    
//               content.text().then(function (html) {
//                 $(_this).parents('.product-form').find('.collection_product_grid_price').html(html);
//               });
//             });
// });

// $(document).on('click', '.cstm__grid_label', function () {

//   const $this = $(this);
//   const $product = $this.closest('.product-item');

//   $this
//     .closest('.product-form')
//     .find('.cstm__grid_label')
//     .removeClass('active_variant');

//   $this.addClass('active_variant');

//   const media_img = $this.attr('media-img');
//   const media_id = $this.attr('data-media-id');

//   const img_media_id = $product
//     .find('.product-item__bg__under')
//     .attr('data-media-id');

//   const available = $this.attr('data-available');

//   console.log("available>>>", available);
//   console.log("media_img>>>", media_img);
//   console.log("media_id>>>", media_id);
//   console.log("img_media_id>>>", img_media_id);

//   $product
//     .find('.product-item__bg__under')
//     .toggleClass('show', media_id == img_media_id);

// });




$('body').on('click','.cstm__add_to_cart',function(){
  console.log("hello12");
  var id;
  if($(this).hasClass('indexTrue')){
    console.log("9");
    id = $(this).parents('.product-form').find('.cstm__grid_label.active_variant').attr('data-id')
  }
  else{
    console.log("10");
    id= $(this).parents('.atcBTn').find('.cstm__grid_label.active_variant').attr('data-id');
  }

var prop = $(this).attr('data_prop');
  console.log("prop>>>",id);
var _this = this;
$(_this).addClass('adding__in_cart');
  maxlimit(id).then((e)=>{
        if(e == true ){
jQuery.ajax({
              type: 'POST',
              url: '/cart/add.js',
              dataType: 'json',
              data: 'quantity=' + 1 + '&id=' + id+'&properties[free_comb]='+prop,
              async:false,
              beforeSend: function () {
                $(_this).addClass('adding__in_cart');
              },
              success: function(data){
                addQntity(data,_this);
                setTimeout(function(){
                 $(_this).removeClass('adding__in_cart');
                  // $('[data-cart-toggle]').trigger('click');
                    $.getJSON('/cart.json').then(cart => {
                     // console.log(cart);
                    $('.cart__popup_count').text(cart.item_count+' Item'); 
                      $('.cart_popup_price').text(Shopify.formatMoney(cart.total_price));
                  $('.header__cart__status').text(cart.item_count).attr('data-cart-count',cart.item_count); 
                   $('.cart__popup_main,.cart__items_count_price').show(); 
                    })
                  setTimeout(function(){
                  $('.cart__popup_main').hide();
                }, 2000);
                },600);
              },
              error:function(e){
                 setTimeout(function(){
                   $(_this).removeClass('adding__in_cart');
                },600);
              }
            });
    
        }
    else{
      setTimeout(function(){
                   $(_this).removeClass('adding__in_cart');
                },600);
       alert('Your Cart Limit Exceed');
    }
  });
         
});

function maxlimit(data){
  return fetch("/cart.js").then(this)
                    .then((e) => e.json()).then((t) => {
                      console.warn(t);
                      if(t.item_count > 24){
                        return false;
                      }
                       var prod_id =data;
                       var prod_quant =1
                      const getProduct = t.items.find(item=> item.variant_id == prod_id); 
                        if(getProduct != undefined){
                        var total__quit = parseInt(getProduct.quantity);                        
                        }
                        else{
                        var total__quit =0;
                        }
                        var sum_cart =parseInt(prod_quant)+parseInt(total__quit); 
                      //    var sum_total_incart = parseInt(t.item_count)+parseInt(total__quit)+parseInt(prod_quant);
                      //   console.warn(sum_total_incart);
                      // if(sum_total_incart >25 ){
                      //   return false;
                      // }
                      // else if(sum_cart > 5 ){
                      if(sum_cart > 5 ){
                        return false;
                      }else{return true}
                    })
 }

function addQntity(data,_this) {
 console.log(data.properties.free_comb,"ddddd"); 
 var qtyhtml =  `<div  class="cstm_add_qty cstm_collection_visible__btn variant__${data.id}">
            <span id="quantity-btn-atc" class="cart__quantity quantity-btn-atc " data-quantity-holder> <a
                type="button"
                class="quantity_btn cart__quantity-minus minus"
                data-quantity-minus
                data-quantity-button
                data-quantity ="${data.quantity}"
                data-variant-id="${data.id}"
                item_count="${data.quantity}"
                data-vid ="${data.id}"
                data_prop ="${data.properties.free_comb}"
              >
               <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" viewBox="0 0 20 20"><path fill="#444" d="M17.543 11.029H2.1A1.032 1.032 0 011.071 10c0-.566.463-1.029 1.029-1.029h15.443c.566 0 1.029.463 1.029 1.029 0 .566-.463 1.029-1.029 1.029z"/></svg>
              </a>
              <input readonly style = "border:none; pointer-events:none"
                type="number"
                name="updates[]"
                data-variant-id="${data.id}"
                id="updates_${data.id}"
               class="cart__quantity-field cstm-field"
                data-quantity-field
                data-id="${data.id}"
                value="${data.quantity}"
                title="${data.product_title}"
                pattern="[0-9]*"
                 data-vid ="${data.id}"
              >
              <a
                type="button"
                class="quantity_btn cart__quantity-plus plus" 
                data-quantity-plus
                data-quantity-button
                data-quantity ="${data.quantity}"
                data-variant-id="${data.id}"
                item_count="1"
                 data-vid ="${data.id}"
                data_prop ="${data.properties.free_comb}"
              >
                <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" viewBox="0 0 20 20"><path fill="#444" d="M17.409 8.929h-6.695V2.258c0-.566-.506-1.029-1.071-1.029s-1.071.463-1.071 1.029v6.671H1.967C1.401 8.929.938 9.435.938 10s.463 1.071 1.029 1.071h6.605V17.7c0 .566.506 1.029 1.071 1.029s1.071-.463 1.071-1.029v-6.629h6.695c.566 0 1.029-.506 1.029-1.071s-.463-1.071-1.029-1.071z"/></svg>
              </a>
            </span>
          </div>`;
     // $(_this).parents('.product-form').find('.cstm__add_to_cart').before(qtyhtml);
     // $(_this).parents('.product-form').find('.cstm__add_to_cart').hide();
  
   if($(_this).parents('.product-form')){
  $(_this).parents('.product-form').find('.cstm__add_to_cart').before(qtyhtml);
   $(_this).parents('.product-form').find('.cstm__add_to_cart').hide();
  }
  else{
     $(_this).parents('.atcBTn').find('.cstm__add_to_cart').before(qtyhtml);
   $(_this).parents('.atcBTn').find('.cstm__add_to_cart').hide();
    
  }
  
 }